import React from 'react';
import './StudentDashboard.css';
import { useAuth } from '../../AuthContext';
import FeeDetailsCard from './FeeDetailsCard';
import ClassScheduleCard from './ClassScheduleCard';
import DashboardCalendar from './DashboardCalendar';
import {
  StudentInfoCard,
  GpaPerformanceCard,
  AttendanceCard,
  RecentMessagesCard,
  DocumentsCard,
} from './student/StudentDashboardCards';

const StudentDashboard = () => {
  const { user, studentInfo, orgId, parentOrgId } = useAuth();
  const effectiveParentOrgId = parentOrgId || user?.parentOrgId || user?.orgDetails?.parentOrgId || sessionStorage.getItem('parentOrgId') || localStorage.getItem('parentOrgId') || '';
  const isSmallOrg = effectiveParentOrgId === 'SMALLORG-001';
  const userId = studentInfo?.userId || user?.userId || user?.id;
  const classId = studentInfo?.classId || user?.studentInfo?.classId || user?.classId;

  return (
    <div className={`sd-dashboard ${isSmallOrg ? 'sd-small-org' : ''}`}>
      <div className="sd-dashboard-grid">
        <StudentInfoCard />
        <RecentMessagesCard />
        {!isSmallOrg && <GpaPerformanceCard userId={userId} />}
        <ClassScheduleCard userId={userId} classId={classId} />
        <AttendanceCard />
        <FeeDetailsCard userId={userId} classId={classId} />
        <DocumentsCard />
        <DashboardCalendar orgId={orgId} className="sd-card sd-schedule-card" maxVisibleEvents={3} />
      </div>
    </div>
  );
};

export default StudentDashboard;
